import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { CLIENT_STATUS } from "./actionType";
import { clientActiveStatus } from "../../../helpers/backend_helper";
import toast from "react-hot-toast";
import { getClientStatusFail, getClientStatusSuccess } from "./action";

function* clientsStatus(checked) {
  try {

    const response = yield call(clientActiveStatus, {
      clientId: checked.payload.isGetid,
      clientStatus: checked.payload.checked,
    });
    if (response.status === "success") {
      toast.success(response.message);
      checked.payload.history.push('/clients');
      yield put(getClientStatusSuccess(response))
    } else {
      yield put(getClientStatusFail(response))
      toast.error(error.response.data.message)
    }
  } catch (error) {
    yield put(getClientStatusFail(error))
    toast.error(error.response.data.message)
  }
}
function* ClientStatusSaga() {
  yield takeEvery(CLIENT_STATUS, clientsStatus);

}

export default ClientStatusSaga;
